//输出通用axios实例
import axios from 'axios';
 
const instance = axios.create({
	timeout: 10000,
	headers: {
		'Content-Type': "application/json;charset=utf-8",	
	},
	withCredentials: true
});
 
export default {
  userLogin ( data ) {
    return instance.post('/api/user/login', data);
  },
  allUser () {
    return instance.post('/api/user');
  },
  allProduct () {
   return instance.post('/api/product')
  },
  upload (data) {
    return instance.post('/api/upload',data)
  },
  regist (data){
  	return instance.post('http://219.153.108.38:8081/my51cadmin/apiv2/GetDevStreamUrl.php',data)
  },
  getUrl (data){
  	return instance.post('/api/my51cadmin/apiv2/GetDevStreamUrl.php',data)
  }
};


// WEBPACK FOOTER //
// ./src/api/index.js